import { FC, useEffect, useState } from 'react';
import { Stack } from '@mantine/core';
import { IconBuildingSkyscraper } from '@tabler/icons';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/modal';
import { CardContainer } from '../../cardContainer';
import { IListItemProps, ListItem } from '../../listItem';
import { ROUTES } from '@/containers/routes/constants';
import { isSaaS } from '@/lib/utils/access';
import { CreateFilialForm } from '@/containers/pages/filials/components/create-item/createForm';
import { useAppSelector } from '@/hooks/redux/redux';
import useHomeWidgetSlice from '@/store/homeWidget/useHomeWidgetSlice';

interface IFilialSectionProps {
  filialId: number;
}

export const FilialSection: FC<IFilialSectionProps> = ({ filialId }) => {
  const { t } = useTranslation();
  const [{ data: filialsData }] = useHomeWidgetSlice().useFilialWidget().useState();
  const { LoadFilialSection } = useHomeWidgetSlice().actions;
  const { Settings } = useAppSelector((state) => state.userInfo);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    LoadFilialSection();
  }, []);

  const handleCreateFilial = () => {
    setIsModalOpen(true);
  };

  // Меню филиалов
  const filialMenu: IListItemProps = {
    withCheck: false,
    items: [
      {
        name: t('filials.list'),
        link: ROUTES.filials.path,
        badge: filialsData?.TotalCount || 0
      },
      ...(!isSaaS(Settings)
        ? [
            {
              name: t('roles.addFilial'),
              openModal: handleCreateFilial
            }
          ]
        : []),
      {
        name: t('filials.configureLdap'),
        link: `${ROUTES.filials.edit.clearPath}/${filialId}/${ROUTES.filials.edit.pages.auth.ldap}`
      }
    ]
  };

  return (
    <>
      <CardContainer sectionName={t('navigation.units')} Icon={IconBuildingSkyscraper}>
        <Stack gap="11px" sx={{ width: '100%' }}>
          <ListItem items={filialMenu.items} withCheck={filialMenu.withCheck} />
        </Stack>
      </CardContainer>
      <Modal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={t('filials.create')}
        zIndex={1002}
      >
        <CreateFilialForm onSuccess={LoadFilialSection} onClose={() => setIsModalOpen(false)} />
      </Modal>
    </>
  );
};
